import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import remAndPhoneConfig from './toolJs/remConfig'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { Toast } from 'vant'
Vue.use(Toast).use(ElementUI)

remAndPhoneConfig()
window.onresize = remAndPhoneConfig

//使用香港语言
import { Locale } from 'vant'
import zhHK from 'vant/lib/locale/lang/zh-HK'
Locale.use('zh-HK', zhHK)

import {
  NavBar,
  Progress,
  Swipe,
  SwipeItem,
  RadioGroup,
  Radio,
  Checkbox,
  CheckboxGroup,
  Field,
  Picker,
  Popup,
  Area,
  DatetimePicker,
  Cell,
  CellGroup,
  Loading,
  NumberKeyboard,
  Row,
  Col,
  Divider,
} from 'vant'

Vue.use(NavBar)
  .use(Progress)
  .use(Swipe)
  .use(SwipeItem)
  .use(RadioGroup)
  .use(Radio)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Field)
  .use(Picker)
  .use(Popup)
  .use(Area)
  .use(DatetimePicker)
  .use(Cell)
  .use(CellGroup)
  .use(Loading)
  .use(NumberKeyboard)
  .use(Row)
  .use(Col)
  .use(Divider)

import 'vant/lib/index.css'

import './assets/css/public_qjc.css' //公用css
Vue.config.productionTip = false

//如果为PC打开则跳转至PC端

import wx from 'weixin-js-sdk'

//檢測token是否有效  检测是否完善信息
import { getUserHasUse } from '@/js/axios'
import { getToken } from '@/js/auth'
import { Base64 } from 'js-base64'

router.beforeEach(async (to, from, next) => {
  const access_token = getToken()
  console.log('router', to.path, access_token, store.state.isLogin)
  console.log(store.state.firstUse, store.state.firstFree)

  if (access_token) {
    if (store.state.isLogin) {
      if (to.path === '/login') {
        return next({ path: '/' })
      }
      return next()
    }

    const res = await getUserHasUse()
    if (res.code === 200) {
      const data = JSON.parse(Base64.decode(res.data))
      console.log('hasUse', data)

      const { firstUse = 0, firstFree = 0 } = data

      store.commit('changeFirstUse', firstUse)
      store.commit('changeFirstFree', firstFree)
      store.dispatch('login', access_token)
      return next()
    }

    if (to.meta.needLogin) {
      return next({ path: '/login' })
    }

    return next()
  } else {
    if (to.meta.needLogin) {
      return next({ path: '/login' })
    }

    return next()
  }

  // 登录检测
  // if (to.meta.needLogin) {
  //   if (store.state.isLogin) {
  //     if (to.path == '/login') {
  //       next({
  //         path: '/',
  //       })
  //       return
  //     }
  //     if (access_token) {
  //       next()
  //     } else {
  //       store.dispatch('exit')
  //       next({
  //         path: '/',
  //       })
  //     }
  //   } else {
  //     next({
  //       path: '/',
  //     })
  //   }
  // } else {
  //   next()
  // }
})

//页面跳转顶头开始
router.afterEach((to, from, next) => {
  //更改標題
  document.title = to.meta.title

  window.scrollTo(0, 0)
})

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
